import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import TeacherPermissionRoute from "./components/RolesAndPermissions/routes/TeacherPermission";
import { AssessmentDetails } from "Assessments";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";

export default store => ({
  path: ":section_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-profile" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    TeacherPermissionRoute(),
    ClassRoomDetails(store),
    AssessmentDetails(store),
  ],
});
